import { AxiosError, AxiosResponse } from "axios";
import { businessClient } from "./api";

export const getInventoryItems = async (
  categoryId: number | string | null | undefined,
  siteoneLocalItemSearch: string | null | undefined = null,
  siteoneLocalItemNumberSearch: string | null | undefined = null
) => {
    const onSuccess = (response: AxiosResponse) => {
      return response.data;
    };

    const onError = (error: AxiosError) => {
      return console.error(error);
    };

    //! Warning: this will get only those items NOT linked to a vendor, for the VendorItemLinkModalBody
    return businessClient({
      method: "GET",
      url: "/inventory/item",
      params: { category: categoryId, siteoneLocalItemSearch: siteoneLocalItemSearch, siteoneLocalItemNumberSearch: siteoneLocalItemNumberSearch },
    })
      .then(onSuccess)
      .catch(onError);
};

export const getInventoryCategories = async () => {
  const onSuccess = (response: AxiosResponse) => {
    return response.data;
  };

  const onError = (error: AxiosError) => {
    return console.error(error);
  };

  return businessClient({
    method: "GET",
    url: "/inventory/category",
  })
    .then(onSuccess)
    .catch(onError);
};

export const getSiteoneInventoryCategories = async () => {
  const onSuccess = (response: AxiosResponse) => {

    return response.data;
  };

  const onError = (error: AxiosError) => {
    return console.error(error);
  };

  return businessClient({
    method: "GET",
    url: "/inventory/siteone/category",
    // params: { category_id: 0, type: "ALLITEMS" },
  })
    .then(onSuccess)
    .catch(onError);
}

export const getSiteoneInventoryItems = async (categoryId: number | string | null | undefined, siteoneItemSearch: string | null | undefined = null, siteoneItemNumberSearch: string | null | undefined = null) => {
  const onSuccess = (response: AxiosResponse) => {
    return response.data;
  };

  const onError = (error: AxiosError) => {
    return console.error(error);
  };

  return businessClient({
    method: "GET",
    url: "/inventory/siteone/item",
    params: { categoryId: categoryId, siteoneItemSearch: siteoneItemSearch, siteoneItemNumberSearch: siteoneItemNumberSearch },
  })
    .then(onSuccess)
    .catch(onError);
};

export const saveSiteoneLinkedItem = async (
  itemId: string | number | null | undefined,
  siteoneItemId: string | number | null | undefined
) => {

  const onSuccess = (response: AxiosResponse) => {
    return response.data;
  };

  const onError = (error: AxiosError) => {
    return console.error(error);
  };

  return businessClient({
    method: "POST",
    url: "/inventory/siteone/item/link",
    data: {
      itemId,
      siteoneItemId,
    },
  })
    .then(onSuccess)
    .catch(onError);
}

export const changeSiteoneItemLink = async (
  itemId: string | number | null | undefined,
  siteoneItemId: string | number | null | undefined
) => {
  const onSuccess = (response: AxiosResponse) => {
    return response.data;
  };

  const onError = (error: AxiosError) => {
    return console.error(error);
  };

  return businessClient({
    method: "POST",
    url: "/inventory/siteone/item/change-link",
    data: {
      itemId,
      siteoneItemId,
    },
  })
    .then(onSuccess)
    .catch(onError);
}

export const unlinkSiteoneItemLink = async (
  itemId: string | number | null | undefined,
  siteoneItemId: string | number | null | undefined
) => {
  const onSuccess = (response: AxiosResponse) => {
    return response.data;
  };

  const onError = (error: AxiosError) => {
    return console.error(error);
  };

  return businessClient({
    method: "POST",
    url: "/inventory/siteone/item/unlink",
    data: {
      itemId,
      siteoneItemId,
    },
  })
    .then(onSuccess)
    .catch(onError);
}

